// Лесно за смяна: тук се задават контактите на Айлян.
export const PHONE_DISPLAY = "+359 89 273 5549";
export const PHONE_DIGITS = "359892735549"; // без + и интервали, за WhatsApp
export const INSTAGRAM_URL = "https://www.instagram.com/bouquetsbyaylii";
export const INSTAGRAM_HANDLE = "@bouquetsbyaylii";

export function whatsappLink(text) {
  const t = text ? `?text=${encodeURIComponent(text)}` : "";
  return `https://wa.me/${PHONE_DIGITS}${t}`;
}
